import { SerializedStyles } from '@emotion/react';
import { Theme } from './theme';

export function styleIf<T extends string>(prop: T, fn: (theme: Theme) => SerializedStyles) {
  return (p: { theme: Theme } & { [key in T]?: boolean }) => p[prop] && fn(p.theme);
}
